import React from 'react';

import { QStack, QTypography } from 'quotient/vNext';

type ToastContentProps = {
  title?: string;
  description?: string;
};

export const ToastContent: React.VFC<ToastContentProps> = ({ title, description }) => {
  return (
    <QStack gap={0.5} mt={0.5}>
      {title && <QTypography variant="bodySemiBold">{title}</QTypography>}
      {description && <QTypography>{description}</QTypography>}
    </QStack>
  );
};
